module.exports = __webpack_public_path__ + "img/study-zy-active.ebf4e0e4.png";